<div class="row mt-md-2">
  <div class="col-md-6 col-sm-12">
    <cap-kopfdatenelement [histInfo]="version?.histInfo" [value]="version?.name" label="Name"></cap-kopfdatenelement>
    <cap-kopfdatenelement [histInfo]="version?.histInfo" [value]="version?.vorname" label="Vorname"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="version?.histInfo"
      [metaData]="version?.mWeitereVornamen"
      [value]="version?.weitereVornamen"
      label="WeitereVornamen"></cap-kopfdatenelement>
    <cap-kopfdatenelement [histInfo]="version?.histInfo" [value]="" label="Geburtsdatum">
      @if (version?.mGeburtsdatum.access !== "NONE") {
        <span>{{ version.geburtsdatum | dayMonthYearDate }}</span>
      } @else {
        <span>{{ "NotAvailable" | translate }}</span>
      }
    </cap-kopfdatenelement>
    <cap-kopfdatenelement [histInfo]="version?.histInfo" [value]="version?.ledigname" label="Ledigname"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="version?.histInfo"
      [metaData]="version?.mNameEltern"
      [value]="version?.nameEltern"
      label="NameDerEltern"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="version?.histInfo"
      [metaData]="version?.mNameEhegatte"
      [value]="version?.nameEhegatte"
      label="NameEhegatte"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="version?.histInfo"
      [metaData]="version?.mNameAlias"
      [value]="version?.nameAlias"
      label="Alias"></cap-kopfdatenelement>
  </div>
  <div class="col-md-6 col-sm-12">
    <cap-kopfdatenelement [histInfo]="version?.histInfo" [value]="version?.art | translate" label="Art"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="version?.histInfo"
      [metaData]="version?.mBuergerort"
      [value]="version?.buergerort"
      label="Heimatort"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="version?.histInfo"
      [metaData]="version?.mNationalitaet"
      [value]="version?.nationalitaet?.text | translateName"
      label="Nationalitaet"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="version?.histInfo"
      [metaData]="version?.mGeschlecht"
      [value]="version?.geschlecht | translate"
      label="Geschlecht"></cap-kopfdatenelement>
    <cap-kopfdatenelement [histInfo]="version?.histInfo" [value]="version?.unternehmensId | formatUid" label="UID"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="version?.histInfo"
      [metaData]="master?.mEgbpid"
      [value]="master?.egbpid"
      label="EGBPID"></cap-kopfdatenelement>
    <cap-kopfdatenelement label="ErstelltMit">
      <cap-kompakt-timepoint [item]="version?.histInfo.vonTimePoint"></cap-kompakt-timepoint>
    </cap-kopfdatenelement>
    <cap-kopfdatenelement label="GestrichenMit">
      <cap-kompakt-timepoint [item]="version?.histInfo.bisTimePoint"></cap-kompakt-timepoint>
    </cap-kopfdatenelement>
  </div>
</div>
